class ScenarioObj {

	
	constructor() {
		

	}
	
	
	
	
	static getOwner(scenario, ownerId){
		
		
		
		if(!Array.isArray(scenario.landowners) || !scenario.landowners.length)
			return false;
		
		
		var idx = scenario.landowners.findIndex((o)=>{return o.id == ownerId});
		
		if(idx != -1){
			return scenario.landowners[idx];
		}
		
		return false;
	}
	static getPropertyByVindrId(scenario, vindrId){
		
		
		
		if(!scenario.properties || !scenario.properties.features || !scenario.properties.features.length )
			return false;
		
		
		var idx = scenario.properties.features.findIndex((p)=>{return p.properties.vindrid == vindrId});
		
		if(idx != -1){
			return scenario.properties.features[idx];
		}
		
		return false;
	}
	

}

export default ScenarioObj;